import PageLoader from "components/general/PageLoader";
import Seo from "components/general/Seo";
import Pagination from "components/navigation/Pagination";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";
import { Box, HStack, Link, Text, H1, Button, ParagraphSmall } from "components/ui";
import React from "react";
import { useDeleteGroupRoleByIdMutation, useGetGroupRoleQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { Plus, Trash2 } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";
import { useRouter } from "expo-router";
import PressableArea from "components/ui/PressableArea";

type Props = {
	data: any;
	// deleteCatalogue: any;
	setPageNumber: React.Dispatch<React.SetStateAction<number>>;
};

const RoleListing = () => {
	const isMobile = useIsMobile();
	const [pageNumber, setPageNumber] = React.useState(1);
	const { data, isLoading, isFetching } = useGetGroupRoleQuery({ pageNumber });
	const [deleteRole] = useDeleteGroupRoleByIdMutation();
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const router = useRouter();

	return (
		<Box>
			<Box paddingVertical={24}>
				<GridContainer
					noPadding
					style={{
						marginLeft: 0,
						width: "100%",
						maxWidth: "100%",
					}}
				>
					{!isMobile && (data?.list ?? []).length > 0 && (
						<Row style={{ marginLeft: 0, marginRight: 8, marginBottom: 14, marginTop: 14, width: "100%", paddingHorizontal: 16 }}>
							<Col style={{ justifyContent: "center" }} xs={6} md={6}>
								<Text color="$neutral500">Description</Text>
							</Col>
						</Row>
					)}

					{data?.list &&
						data?.list?.map((role) => {
							return (
								<Link
									href={`/admin/roles/${role.id}`}
									key={role.id}
									component={(hovered: boolean) => {
										var styleData = { marginLeft: 0, marginRight: 8, paddingHorizontal: 16, paddingVertical: 18, borderRadius: 8, borderWidth: 1, marginBottom: 14, borderColor: "#E1E9F0" };

										if (hovered) {
											// @ts-ignore
											styleData = { ...styleData, backgroundColor: "#E1E9F0" };
										}

										if (isMobile) {
											return (
												<Row style={styleData} key={role.id}>
													<Col>
														<Row style={{ paddingBottom: 6 }}>
															<Col style={{ flexDirection: "row", justifyContent: "space-between" }}>
																<HStack gap={4}>
																	<Text fontSize={12}>{role.description}</Text>
																</HStack>
															</Col>
														</Row>
													</Col>
													<Col>
														<Row style={{ paddingBottom: 6 }}>
															<Col style={{ flexDirection: "row", justifyContent: "space-between" }}>
																<PressableArea
																	onPress={(ev) => {
																		ev.preventDefault();
																		ev.stopPropagation();
																		deleteRole({ id: Number(role.id) });
																	}}
																	component={(hovered: boolean) => <Trash2 size={18} color={resolvedPrimarylight} opacity={hovered ? 1 : 0.5} />}
																></PressableArea>
															</Col>
														</Row>
													</Col>
												</Row>
											);
										}

										return (
											<Row style={styleData} key={role.id}>
												<Col style={{ justifyContent: "center" }} xs={11} md={11}>
													<HStack gap={8}>
														<Text>{role.description}</Text>
													</HStack>
												</Col>
												<Col style={{ justifyContent: "center" }} xs={1} md={1}>
													<PressableArea
														onPress={(ev) => {
															ev.preventDefault();
															ev.stopPropagation();
															deleteRole({ id: Number(role.id) });
														}}
														component={(hovered: boolean) => <Trash2 size={24} color={resolvedPrimarylight} opacity={hovered ? 1 : 0.5} />}
													></PressableArea>
												</Col>
											</Row>
										);
									}}
								></Link>
							);
						})}
				</GridContainer>
			</Box>

			<Pagination pageCount={data.metaData?.pageCount} pageNumber={data.metaData?.pageNumber} onChangePage={setPageNumber} />
		</Box>
	);
};

export default RoleListing;
